import { type SelectDataObject } from '../_tools/inputfields/Select';

const sIntSteuer: (mwst: number) => SelectDataObject[] = (mwst) => [
    { i: 0, t: 'differenzbesteuert nach §25a' },
    { i: 1, t: 'regelbesteuert (' + mwst + '%)' },
    { i: 16, t: 'regelbesteuert (16%)', hidden: true },
    { i: 19, t: 'regelbesteuert (19%)', hidden: true },
];
export default sIntSteuer;
